/**
 * @desc 获取订舱计划明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CabinMasterResponseDto>;
export function request(crno: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfScattered/getDetail/${crno}`, {
      method: "POST",

      ...options,
    }),
  );
}
